import {i18n} from '@yourcoach/i18n';

import type {ConferenceType} from '../types';

import {getCalendarCheckAnimation} from '../../../assets/animations/calendar-check';
import {alert} from '../../../components/alert';
import {msi} from '../../../styles/normalizeSize';
import {LottieView} from '../../../uikit/LottieView';
import {Text} from '../../../uikit/Text';
import {View} from '../../../uikit/View';
import {logger} from '../../../utils/logger';
import {TestID} from '../../../utils/test-utils/data-test-id';

interface Props {
  coachName: string;
  dateString: string;
  type: ConferenceType;
}

export const showSuccessBookingAlert = async ({
  coachName,
  dateString,
  type,
}: Props) => {
  return alert.show({
    beforeTitleSlot: () => (
      <LottieView
        autoPlay
        colorify={{
          color: 'global2',
        }}
        keepLastFrame
        loop={false}
        source={getCalendarCheckAnimation}
        speed={1.5}
        style={{alignSelf: 'center', height: msi(200), width: msi(200)}}
        testID={TestID.bookConference.block.animation}
      />
    ),
    buttons: [
      {
        label: i18n.t('shared:ok'),
        onClick: () => {
          logger.event('scheduled_session_confirm_tap');
        },
        scheme: 'secondary',
      },
    ],
    renderMessage: () => (
      <View style={{alignItems: 'center', flexDirection: 'column'}}>
        <Text variant={'subtitle'}>
          {i18n.t('shared:book_conference.schedule_popup_message', {
            coach: coachName,
          })}
        </Text>
        <Text color={'text5'} variant={'subtitle'}>
          {dateString}
        </Text>
      </View>
    ),
    title:
      /**
       * @i18n_parser
       * t('shared:session_scheduled.chat')
       * t('shared:session_scheduled.intro_call')
       * t('shared:session_scheduled.live')
       */
      i18n.t(`shared:session_scheduled.${type}`),
    variant: 'promo',
  });
};
